import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function NotVisbleQRPH({ navigation }) {
  const [details, setDetails] = useState({
    not_visible_p1_door_sticker_description: "",
    qrph_door_hanger_unvisible_reason: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    newErrors.qrph_door_hanger_unvisible_reason = !details.qrph_door_hanger_unvisible_reason;
    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some(Boolean);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validate()) {
      if (navigation && navigation.next) navigation.next();
    }
  };

  const handleBack = () => {
    navigation.previous();
  };


  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">NOT VISIBLE QRPH DOOR HANGER</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                

                  {/* Reason QRPH door hanger not visible */}
                  <Form.Group className={`mb-4 ${errors.qrph_door_hanger_unvisible_reason ? 'form-group-error' : ''}`}>
                    <Form.Label className="form-label">
                      Reason QRPH door hanger not visible <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {[
                        "HO restriction",
                        "mall restriction",
                        "no Maya customers",
                        "static QR (SQR) has been pulled out",
                        "clean store policy",
                        "static QR (SQR) is not used/boxed",
                        "missing",
                        "no QRPH door hanger",
                        "no area/space to display",
                        "priority to display P1 door hanger/sticker",
                        "other reason",
                      ].map((reason) => (
                        <div key={reason} className={`form-radio-item${details.qrph_door_hanger_unvisible_reason === reason ? " selected" : ""}`}>
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="qrph_door_hanger_unvisible_reason"
                              value={reason}
                              label={reason}
                              checked={details.qrph_door_hanger_unvisible_reason === reason}
                              onChange={handleChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {errors.qrph_door_hanger_unvisible_reason && (
                      <div className="form-error">
                        Required
                      </div>
                    )}
                  </Form.Group>

                  {/* Other reason QRPH door hanger not visible */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Other reason QRPH door hanger not available
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="qrph_door_hanger_unvisible_reason"
                      value={details.qrph_door_hanger_unvisible_reason || ''}
                      onChange={handleChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                <div className="form-nav-btns">
                  <AppButton
                    onClick={handleBack}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back 
                  </AppButton>
                  <AppButton
                    onClick={handleSubmit}
                    variant="next"
                    className="form-btn variant-primary"
                  >
                     Next →
                  </AppButton>
                </div>
              </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default NotVisbleQRPH;
